import React from "react";
import NotificationSystemComponent from "./NotificationSystemComponent";
import * as defaultToasts from "./toasts/toasts";

export default ({toasts}) => {

    return <NotificationSystemComponent toasts={toasts || defaultToasts}/>

}